<ion-item button detail="false" [lines]="itemLine">
    @if(team){
        <ion-avatar slot="start">
            <app-team-profile-image [team]="team"></app-team-profile-image>
        </ion-avatar>
    }

    <ion-label class="ion-text-wrap">
        {{ team.name }}
        <p *ngIf="showDetails">
          <span *ngIf="team.type">{{ team.type.name }} | </span
          ><span *ngIf="team.subtype">{{ team.subtype.name }} | </span>Players:
          {{ team.participants.length }}
        </p>
    </ion-label>
    @if (showRemoveTeam) {
        <ion-button
            color="danger"
            slot="end"
            (click)="triggerRemoveTeam()"
            fill="clear"
        >
           <ion-icon slot="icon-only" name="remove-circle"></ion-icon>
        </ion-button>
    }
</ion-item>
